import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const ArrowDown = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.00008 14.1668C7.87341 14.1668 7.74675 14.1202 7.64675 14.0202L3.60008 9.9735C3.40674 9.78016 3.40674 9.46016 3.60008 9.26683C3.79341 9.0735 4.11341 9.0735 4.30674 9.26683L8.00008 12.9602L11.6934 9.26683C11.8867 9.0735 12.2067 9.0735 12.4001 9.26683C12.5934 9.46016 12.5934 9.78016 12.4001 9.9735L8.35341 14.0202C8.25341 14.1202 8.12675 14.1668 8.00008 14.1668Z"
          fill={color}
        />
        <path
          d="M8.00008 14.0535C7.72675 14.0535 7.50008 13.8268 7.50008 13.5535V2.3335C7.50008 2.06016 7.72675 1.8335 8.00008 1.8335C8.27341 1.8335 8.50008 2.06016 8.50008 2.3335V13.5535C8.50008 13.8268 8.27341 14.0535 8.00008 14.0535Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default ArrowDown;
